// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Swh8","name":"styles_name__3rS_h","phone":"styles_phone__2cKYT"};